import React from "react";

import { BCBAResponseToRBTQuestionGraph } from "@pages/VideoAnalytics/BCBAs/GraphAndRawData/BCBAResponseToRBTQuestion/BCBAResponseToRBTQuestionGraph";
import { BCBAResponseToRBTQuestionRawData } from "@pages/VideoAnalytics/BCBAs/GraphAndRawData/BCBAResponseToRBTQuestion/BCBAResponseToRBTQuestionRawData";
import { useVideoAnalytics } from "@providers/VideoAnalyticsProvider";

interface BCBAResponseToRBTQuestionProps {
  isResponseRate: boolean;
}
export const BCBAResponseToRBTQuestion: React.FC<BCBAResponseToRBTQuestionProps> = ({ isResponseRate }) => {
  const { selectedDialogTab } = useVideoAnalytics();
  return (
    <div>
      {selectedDialogTab === "Raw Data" ? (
        <BCBAResponseToRBTQuestionRawData isResponseRate={isResponseRate} />
      ) : (
        <BCBAResponseToRBTQuestionGraph />
      )}
    </div>
  );
};
